import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';

import Checkbox from '~/modules/coreUI/components/legacies/Checkbox';
import { LargeSpacer } from '~/modules/coreUI/components/legacies/Spacers';

const OptionsList = ({ filterCategoryName, listOfOptions, onOptionClicked }) => {
  const ListOfOptionsUI = styled.div`
    display: block;
    max-height: 200px;
    overflow: auto;
  `;
  return (
    <ListOfOptionsUI>
      {listOfOptions.map(filterOption => (
        <React.Fragment key={filterOption.name}>
          <Checkbox
            elemID={filterOption.value}
            label={filterOption.name}
            defaultChecked={filterOption.selected}
            onClick={() => onOptionClicked(filterCategoryName, filterOption)}
            value={filterOption.display_name}
          />
          <LargeSpacer />
        </React.Fragment>
      ))}
    </ListOfOptionsUI>
  );
};

OptionsList.propTypes = {
  listOfOptions: PropTypes.instanceOf(Array).isRequired,
  onOptionClicked: PropTypes.func.isRequired,
  filterCategoryName: PropTypes.string.isRequired,
};

export default OptionsList;
